import {useQuery} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

export function useAgencyActivity(agencyId: string, market: string | undefined, enabled: boolean, isSelfService = false) {
    const query = useQuery({
        queryKey: ['b2b-agency-activity', agencyId],
        queryFn: () => b2bMetricsRepository.getB2BAgencyActivity(agencyId, market, isSelfService),
        enabled: enabled && !!agencyId,
    })

    return {
        activity: query.data,
        isLoadingActivity: query.isLoading,
        activityError: query.error,
    }
}
